import React from 'react';
import './reasonSection.css';

const reasons = [
    {
        id: '01',
        title: 'Timely Completion',
        description: 'We deliver on schedule without ever compromising on quality.'
    },
    {
        id: '02',
        title: 'Minimal Disruption',
        description: 'We understand the importance of continuity, which is why we meticulously plan our work to minimize disruption to your operations through proven and time-tested procedures.'
    },
    {
        id: '03',
        title: 'Eco-Friendly Solutions',
        description: 'We prioritize sustainability by using eco-friendly materials, low-VOC paints, and membranes to protect both your building and the environment. Our practices adhere to Vancouver’s green building standards, ensuring long-term value and compliance.'
    },
    {
        id: '04',
        title: 'Comprehensive Services',
        description: 'From exterior painting to structural repairs, investigations and window cleaning, HRD Painting and Restoration provides complete property maintenance solutions tailored to your needs.'
    },
    {
        id: '05',
        title: 'Safety and Compliance',
        description: 'With over two decades of experience, we prioritize safety, efficiency, and full compliance with local regulations, ensuring your building projects are executed flawlessly and responsibly.'
    },
];

const ReasonSection = () => (
    <div className="container reasons-section py-5">
        <div className="row">
            {reasons.map((r) => (
                <div key={r.id} className="col-md-4 mb-4">
                    <div className="reason-card">
                        <div className="reason-header">
                            <span className="reason-number">{r.id}</span>
                            <h4 className="reason-title line-height-clss">
                                <span>{r.title.split(' ')[0]}</span>
                                {' '}
                                {r.title.split(' ').slice(1).join(' ')}
                            </h4>
                        </div>
                        <p className="reason-description casper-normal">{r.description}</p>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default ReasonSection;
